var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12585",
    "data-name": "Group 12585",
    transform: "translate(-18854 -547)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_460",
    "data-name": "Ellipse 460",
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    transform: "translate(18854 547)",
    fill: "#25d366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "whatsapp_2_",
    "data-name": "whatsapp (2)",
    d: "M40.825,6.976a23.8,23.8,0,0,0-37.45,28.7L0,48l12.614-3.308a23.783,23.783,0,0,0,11.371,2.9h.01A23.8,23.8,0,0,0,40.825,6.976m-16.831,36.6h-.008A19.75,19.75,0,0,1,13.92,40.817l-.722-.428L5.713,42.351l2-7.3-.47-.748a19.778,19.778,0,1,1,16.753,9.265M34.842,28.766c-.595-.3-3.518-1.735-4.063-1.934s-.941-.3-1.338.3-1.536,1.934-1.883,2.33-.694.446-1.288.149a16.239,16.239,0,0,1-4.781-2.95,17.914,17.914,0,0,1-3.307-4.117c-.347-.6-.037-.917.261-1.213.267-.266.595-.694.892-1.041a4.054,4.054,0,0,0,.594-.992,1.094,1.094,0,0,0-.05-1.041c-.149-.3-1.338-3.223-1.833-4.413-.483-1.159-.973-1-1.338-1.02-.346-.017-.743-.021-1.139-.021a2.185,2.185,0,0,0-1.585.744A6.665,6.665,0,0,0,11.9,18.5c0,2.925,2.13,5.752,2.428,6.148s4.192,6.4,10.156,8.974a34.244,34.244,0,0,0,3.389,1.252,8.155,8.155,0,0,0,3.745.235c1.142-.171,3.517-1.438,4.013-2.826a4.967,4.967,0,0,0,.347-2.826c-.149-.248-.545-.4-1.139-.694",
    transform: "translate(18882.105 574.499)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.99b6276ac75f52a4cf221615310060be.svg";
export { ForwardRef as ReactComponent };